var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg89869A35Da087B8690636D97B32Ac04D11727C89(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 2.76397 2.76442",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.76397 0H0V2.76442H2.76397V0Z",
    fill: "var(--fill-0, #212F3F)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg89869A35Da087B8690636D97B32Ac04D11727C89);
export default __webpack_public_path__ + "static/media/89869a35da087b8690636d97b32ac04d11727c89.249c5668c25a2ccd33e388cfc0f6adda.svg";
export { ForwardRef as ReactComponent };